import * as DropdownMenuPrimitive from "@radix-ui/react-dropdown-menu";
import type { ComponentProps } from "react";
import { cn } from "@/lib/utils";

type DropdownMenuItemProps = ComponentProps<typeof DropdownMenuPrimitive.Item> & { inset?: boolean };

function DropdownMenuItem({ className, inset, ...props }: DropdownMenuItemProps) {
  return (
    <DropdownMenuPrimitive.Item
      className={cn(
        "relative mx-1 flex cursor-pointer select-none items-center rounded-lg px-3 py-2 text-sm focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:size-4",
        inset && "pl-8",
        className,
      )}
      {...props}
    />
  );
}

export { DropdownMenuItem };
export type { DropdownMenuItemProps };
